<template>
  <section class="product-excess-form">
    <excess-form
      v-if="productId == 11"
      ref="excess-form"
      :formDataLock="formDataLock"
      :is-adjust="isAdjust"
      :oldForm="oldForm"
      :disabled="disabled"
      :form="form" />
    <housemaid-excess-form
      v-else-if="productId == 12"
      ref="housemaid-excess-form"
      :formDataLock="formDataLock"
      :is-adjust="isAdjust"
      :oldForm="oldForm"
      :disabled="disabled"
      :form="form" />
    <decoration-excess-form
      v-else-if="productId == 15"
      ref="decoration-excess-form"
      :formDataLock="formDataLock"
      :is-adjust="isAdjust"
      :oldForm="oldForm"
      :disabled="disabled"
      :form="form" />

    <homefire-excess-form
      v-else-if="productId == 17||productId == 20"
      ref="homefire-excess-form"
      :formDataLock="formDataLock"
      :is-adjust="isAdjust"
      :disabled="disabled"
      :oldForm="oldForm"
      :form="form" />
  </section>
</template>
<script>
import ExcessForm from '@/views/tickets/components/form/excess-form'
import DecorationExcessForm from '@/views/tickets/components/modules/decoration/decoration-excess-form'
import HomefireExcessForm from '@/views/tickets/components/modules/homefire/homefire-excess-form'
import HousemaidExcessForm from '@/views/tickets/components/modules/housemaid/housemaid-excess-form'
import {getReferralHomeExcess} from '@/api/refer'

export default {
  name: 'ProductExcessForm',
  components: {
    ExcessForm,
    DecorationExcessForm,
    HomefireExcessForm,
    HousemaidExcessForm
  },
  props: {
    // productId: {
    //   type: [String, Number],
    //   default: 11
    // },
    form: {
      type: Object,
      default: () => ({})
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isAdjust:{
      type:Boolean,
      default:false
    },
    disabled:{
      type:Boolean,
      default:false
    },
    formDataLock: Number
  },
  data() {
    return {
      excessForm: [],
      excessFormDataLock: 0,
    }
  },
  computed: {
    productId() {
      return this.form.product_id || 11
    }
  },
  watch: {
    // 'form.plan_id': {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     if(val && this.productId == 17) {
    //       this.network().getReferralHomeExcess()
    //     }
    //   }
    // }
  },
  methods: {
    async submitForm() {
      const formKey = {
        11: 'excess-form',
        12: 'housemaid-excess-form',
        15: 'decoration-excess-form',
        17: 'homefire-excess-form',
        20: 'homefire-excess-form'
      }
      let  params ={}
      if([12,15,20].includes(this.productId))
        params = this.$refs[formKey[this.productId]].submitForm()
      if([11].includes(this.productId))
      {
        params = await this.$refs['excess-form'].submitForm()
      }
      // if(this.productId == 17) {
      //   // home fire 返回的是數組
      //   return {
      //     'excess': params
      //   }
      // }
      return params
    },
    network() {
      return {
        getReferralHomeExcess: async () => {
          const { company_id, plan_id, id } = this.form
          const { data } = await getReferralHomeExcess({
            company_id,
            plan_id,
            order_id: id,
            hideLoading: true,
            old_excess:0
          })
          this.excessFormDataLock += 1
          this.excessForm = data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
